import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

export default class extends Controller {
  static values = { url: String }

  connect() {
    this.sortable = Sortable.create(this.element, {
      animation: 150,
      handle: ".drag-handle",
      onEnd: this.onEnd.bind(this)
    })
  }

  disconnect() {
    this.sortable.destroy()
  }

  onEnd() {
    const rows = [...this.element.querySelectorAll("[data-faq-id]")]
    const ids = rows.map(el => el.dataset.faqId)

    rows.forEach((el, i) => {
      const positionEl = el.querySelector("[data-position]")
      if (positionEl) positionEl.textContent = i
    })

    fetch(this.urlValue, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector("[name='csrf-token']").content
      },
      body: JSON.stringify({ faq_ids: ids })
    })
  }
}
